import "./devextreme-theme";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RouterMain from "./router";
import { LicenseManager } from "ag-grid-enterprise";
import { UiFeedbackProvider } from "./context/ui-feedback-context";
import i18n from './utils/i18n/i18n';
import { STRING_LANGUAGE_ULTIMA_MILLA } from './utils/const/string-const';

LicenseManager.setLicenseKey(
  "Boltrack_SRL_DataTerra_1Devs3_January_2020__MTU3ODAzMTIwMDAwMA==1b0705b2298ea9f53185128e48770b09"
);

const savedLanguage = localStorage.getItem(STRING_LANGUAGE_ULTIMA_MILLA);
if (savedLanguage && savedLanguage !== i18n.language) {
  i18n.changeLanguage(savedLanguage);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UiFeedbackProvider>
      <RouterMain />
    </UiFeedbackProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
